// ** React Imports
import { Link } from 'react-router-dom'

// ** Reactstrap Imports
import { Button } from 'reactstrap'

import { getUserData } from '@utils'

// ** Styles
import '@styles/base/pages/page-misc.scss'

const ErrorAbla = () => {
  // ** Hooks
  const userData = getUserData()

  const link =
    userData ? (
      ['gestor', 'super_admin'].includes(userData.role.toLocaleLowerCase()) ? '/management-user/home' : '/management-user/estimates'
      ) : '/'

  return (
    <div className='misc-wrapper'>
      <a className='brand-logo' href='/'>
        <h2 className='brand-text text-primary ms-1'>ABLA</h2>
      </a>
      <div className='misc-inner p-2 p-sm-3'>
        <div className='w-100 text-center'>
          <h2 className='mb-1'>Página não encontrada 🕵🏻‍♀️</h2>
          <p className='mb-2'>Oops! 😖 A URL inserida não foi encontrada em nossos servidores.</p>
          <Button tag={Link} to={link} color='primary' className='btn-sm-block mb-2'>
            Voltar ao início
          </Button>
        </div>
      </div>
    </div>
  )
}
export default ErrorAbla
